export var CHATBOT_INJECT = "CHATBOT_INJECT";
export var CHATBOT_INIT = "CHATBOT_INIT";
export var CHATBOT_INJECT_SUCCESS = "CHATBOT_INJECT_SUCCESS";
export var CHATBOT_INJECT_ERROR = "CHATBOT_INJECT_ERROR";
export var CHATBOT_INIT_SUCCESS = "CHATBOT_INIT_SUCCESS";
export var CHATBOT_INIT_ERROR = "CHATBOT_INIT_ERROR";
export var ADD_LOOKUP_NAMES = "ADD_LOOKUP_NAMES";
export var CHATBOT_UPDATE_ATTRIBUTES = "CHATBOT_UPDATE_ATTRIBUTES";
export var CHATBOT_UPDATE_ATTRIBUTES_SUCCESS = "CHATBOT_UPDATE_ATTRIBUTES_SUCCESS";
export var CHATBOT_UPDATE_ATTRIBUTES_ERROR = "CHATBOT_UPDATE_ATTRIBUTES_ERROR";
export var CHATBOT_ADD_ATTRIBUTES = "CHATBOT_ADD_ATTRIBUTES";
export var CHATBOT_OPEN = "CHATBOT_OPEN";
export var CHATBOT_OPEN_ERROR = "CHATBOT_OPEN_ERROR";
export var CHATBOT_OPEN_SUCCESS = "CHATBOT_OPEN_SUCCESS";
export var CHATBOT_ADD_LOOKUP_NAMES = "CHATBOT_ADD_LOOKUP_NAMES";
export var VERIFY_BENEFIT_WITH_LOOKUP_NAME = "VERIFY_BENEFIT_WITH_LOOKUP_NAME";
export var CHATBOT_CLOSE_CONVERSATION = "CHATBOT_CLOSE_CONVERSATION";
export var CHATBOT_LOG_INTAKE = "CHATBOT_LOG_INTAKE";
export var CHATBOT_LOG_INTAKE_SUCCESS = "CHATBOT_LOG_INTAKE_SUCCESS";
export var CHATBOT_LOG_INTAKE_ERROR = "CHATBOT_LOG_INTAKE_ERROR";
export function injectChatbot(data) {
    return { type: CHATBOT_INJECT, payload: data };
}
export function verifyBenefitsWithLookupName() {
    return { type: VERIFY_BENEFIT_WITH_LOOKUP_NAME };
}
export function injectChatbotSuccess() {
    return { type: CHATBOT_INJECT_SUCCESS };
}
export function injectChatbotError() {
    return { type: CHATBOT_INJECT_ERROR };
}
export function initChatbot() {
    return { type: CHATBOT_INIT };
}
export function initChatbotSuccess() {
    return { type: CHATBOT_INIT_SUCCESS };
}
export function initChatbotError() {
    return { type: CHATBOT_INIT_ERROR };
}
export function addAttributes(data) {
    return { type: CHATBOT_ADD_ATTRIBUTES, payload: data };
}
export function updateAttributes(data) {
    return { type: CHATBOT_UPDATE_ATTRIBUTES, payload: data };
}
export function updateAttributesSuccess() {
    return { type: CHATBOT_UPDATE_ATTRIBUTES_SUCCESS };
}
export function updateAttributesError() {
    return { type: CHATBOT_UPDATE_ATTRIBUTES_ERROR };
}
export function addLookupNames(data) {
    return { type: CHATBOT_ADD_LOOKUP_NAMES, payload: data };
}
export function openChatbot() {
    return { type: CHATBOT_OPEN };
}
export function openChatbotError() {
    return { type: CHATBOT_OPEN_ERROR };
}
export function openChatbotSuccess() {
    return { type: CHATBOT_OPEN_SUCCESS };
}
export function closeConversation() {
    return { type: CHATBOT_CLOSE_CONVERSATION };
}
export var logChatIntakeResults = function (data) { return ({
    type: CHATBOT_LOG_INTAKE,
    payload: data,
}); };
export var logChatIntakeSuccess = function (payload) { return ({
    type: CHATBOT_LOG_INTAKE_SUCCESS,
    payload: payload,
}); };
export var logChatIntakeError = function (payload) { return ({
    type: CHATBOT_LOG_INTAKE_ERROR,
    payload: payload,
}); };
